export default __webpack_public_path__ + "static/media/in-person-facilitation.fd19c9ee.svg";